import { useAnimateWhenVisible } from '../../../hooks/useAnimateWhenVisible'
import '../../shims/ProgressBarShim.css'

/**
 * Sync and test progress — the real Polaris progress bar (`s-progress`), not a hand-built one.
 *
 * `<s-progress>`'s React binding exposes no `ref`/`className` of its own, so the scroll-triggered
 * reveal (`useAnimateWhenVisible`, shared with ColorBar) goes on a plain
 * wrapping `div` instead — it animates the whole bar in from the left, not just its fill.
 */
export function Progress({ value, label }: { value: number; label: string }) {
  const { ref, hasBeenVisible } = useAnimateWhenVisible<HTMLDivElement>()
  return (
    <div
      ref={ref}
      className={`tf-progress-fill${hasBeenVisible ? ' tf-progress-fill--visible' : ''}`}
      style={{ inlineSize: '100%' }}
    >
      <s-progress value={value} max={100} accessibilityLabel={label} />
    </div>
  )
}
